var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-label",class:{ 'gift-label--detail': _vm.isDetail, 'gift-label--lg': _vm.isLg }},[_c('span',{staticClass:"gift-label__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }